import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import cuid from "cuid";
import dayjs from "dayjs";
import { DatePicker } from "antd";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { filterBy } from "@progress/kendo-data-query";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useDispatch, useSelector } from "react-redux";
import AttachementFileIcon from "../../Images/attachment.png";
import MessageBox from "./MessageBox";
import HistoryBox from "./HistoryBox";
import MainLayout from "../layout";
import AttachImage from "../Popups/AttachImage";
import MergeTicketGrid from "./MergeTickets/MergeTickets";
import DropDownField from "../../Shared/DropdownField";
import ReadField from "../../Shared/ReadField";
import TextAreaField from "../../Shared/TextAreaField";
import CheckBoxField from "../../Shared/CheckBoxField";
import { setUrl } from "../../handlers";
import { TICKET_TASK_FILTERS } from "../../constants/TicketTaskFilter";
import { DisplayMsg } from "../../services/toastService";
import { keyRestrict } from "../../utils/array";
import {
  setCommentTicketNo,
  setCommentUserEmail,
  setCurrentClientId,
  setCurrentTicketNo,
  setSearchFrom,
  setTicketComment,
  setUserEmail,
} from "../../store/reducers/SharedLayoutDataSlice";
import { IMAGE_REGEX } from "../../constants/regex";
import { setMergeTicketCustomerId } from "../../store/reducers/TicketTaskFilter";
import { downloadDocument } from "../../services/DocumentApi";
import { downloadFileFromJsonBlob, getMimeType } from "../../utils/helper";
import MyTiffViewer from "../Popups/TifViewer";
import ImagePreview from "./ImagePreview";

let TD_AssigneeDataArr = [];
let TD_AssigneeIds = [];

const DOCUMENT_STORAGE = process.env.REACT_APP_SUPPORT_DOC_STORAGE;

const TicketDetail = (props) => {
  const sharedData = useSelector((state) => state.SharedLayoutData);

  const dispatch = useDispatch();

  const location = useLocation();
  const ticketNo = location.state?.ticketNo;
  const taskType = location.state?.task;

  const navigate = useNavigate();
  const [CommentsData, setCommentsData] = useState([]);
  const [TicketDates, setTicketDates] = useState({
    targetDate: null,
    tickleDate: null,
    createdDate: "",
    updatedDate: "",
  });
  const [ImageData, setImageData] = useState("");
  const [ImageInfo, setImageInfo] = useState({
    ImageData,
    fileName: "",
    filePath: "",
    fileType: "",
  });

  const [fileType, setFileType] = useState("");
  const [Detail, setDetail] = useState({
    printPath: "",
    fileName: "",
    viewable: "A",
    replyComment: "",
    assigneeName: "",
    assigneeValue: "",
    customerId: "",
    practiceName: "",
    noOfProvider: 0,
    comments: "",
  });

  const [ticketDetail, setTicketDetail] = useState();
  const [AssigneeList, setAssigneesOption] = useState([
    { value: "", text: "- SELECT -", team: "", active: "Y" },
  ]);
  const [InternalTeams, setInternalTeams] = useState([]);
  const [InternalAssignees, setInternalAssignees] = useState([]);
  const [boxes, setBoxes] = useState({
    resolution: false,
    history: false,
    select: false,
    viewable: false,
    rplycmnt: false,
    comments: true,
    status: false,
    files: false,
    resolutionBox: true,
    notify: false,
    target: false,
    tickle: false,
    resolutionBtn: false,
  });
  const [HistoryData, setHistoryData] = useState([]);
  const [Trigger, setTrigger] = useState({
    ticketUpdate: false,
    network: true,
    update: false,
    attachment: true,
    ErrMsg: true,
    FileItems: true,
    fileDiv: true,
    category: true,
    typeCategory: true,
    categoryDiv: false,
    Merge: false,
    type: true,
    browser: false,
  });

  const [StatusArray, setStatusArray] = useState(
    TICKET_TASK_FILTERS.STATUS_DATA,
  );
  const [ImagePopup, setImagePopup] = useState(false);
  const [AttachmentFiles, setAttachmentFiles] = useState(null);
  const [TaskhAttachmentFiles, setTaskhAttachmentFiles] = useState(null);

  const fileRef = useRef();
  let currentTeam = "";

  const [myFiles, setMyFiles] = useState([]);
  const [commentFiles, setCommentFiles] = useState([]);
  const onDrop = useCallback(
    (acceptedFiles) => {
      let check = true;
      check = CheckFileSize(acceptedFiles);
      if (check) {
        setCommentFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
        acceptedFiles.map((file) => {
          const reader = new FileReader();
          reader.onload = function (e) {
            setMyFiles((prevState) => [
              ...prevState,
              {
                id: cuid(),
                src: e.target.result,
                fileType: file.type,
                fileName: file.name,
              },
            ]);
          };
          reader.readAsDataURL(file);
          return file;
        });
      }
    },
    [myFiles],
  );

  const CheckFileSize = (fileArray) => {
    for (let i = 0; i < fileArray.length; i++) {
      if (!IsFileSizeValid(fileArray[i])) {
        DisplayMsg(
          "2",
          `File[${fileArray[0].name}] size exceeds the allowed limit`,
        );
        return false;
      }
    }
    return true;
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: !boxes.select ? onDrop : undefined,
  });

  const removeFile = (file) => {
    const newFiles = [...myFiles];
    const newCommentFiles = [...commentFiles];
    newCommentFiles.splice(commentFiles.indexOf(file), 1);
    newFiles.splice(newFiles.indexOf(file), 1);
    setMyFiles(newFiles);
    setCommentFiles(newCommentFiles);
  };

  // const Image = ({ file }) => {
  //   const base64 = file.src.startsWith("data:")
  //     ? file.src.split(",")[1]
  //     : file.src;

  //   const mimeType = getMimeType(base64);

  //   if (file.fileType.includes("image")) {
  //     if (mimeType === "image/tiff") {
  //       return (
  //         <div
  //           className="file-item"
  //           style={{
  //             width: "90px",
  //             display: "flex",
  //             flexDirection: "column",
  //             alignItems: "center",
  //           }}
  //         >
  //           <div
  //             style={{
  //               width: "90px",
  //               height: "60px",
  //               overflow: "hidden",
  //             }}
  //           >
  //             <MyTiffViewer data={base64} />
  //           </div>

  //           <p
  //             style={{
  //               marginTop: "4px",
  //               fontSize: "12px",
  //               textAlign: "center",
  //               wordBreak: "break-word",
  //             }}
  //           >
  //             {file.fileName}
  //           </p>
  //         </div>
  //       );
  //     }

  //     return (
  //       <div className="file-item">
  //         <img
  //           alt={file.fileName}
  //           src={`data:${mimeType};base64,${base64}`}
  //           className="d-block"
  //         />
  //         <p>{file.fileName}</p>
  //       </div>
  //     );
  //   }

  //   return (
  //     <div className="file-item">
  //       <p>{file.fileName}</p>
  //     </div>
  //   );
  // };

  const files = myFiles.map((currentFile) => (

    <div key={currentFile.id} className="mr-5">
      <ImagePreview file={currentFile} />
      <FontAwesomeIcon
        onClick={() => removeFile(currentFile)}
        icon="trash"
        className="cursor-pointer"
        color="red"
        size="lg"
      />
    </div>

    // <div className="mr-5">
    //   <Image file={currentFile} key={`${currentFile.id}-image`} />
    //   <FontAwesomeIcon
    //     onClick={(e) => removeFile(currentFile)}
    //     icon="trash"
    //     color="red"
    //     size="lg"
    //   />
    // </div>
  ));

  const FilesContainer = {
    Files: "undefined",
    name: "messagedetailfile",
    MaxFileSize: "10",
  };

  // sharedData.commentUserEmail === sessionStorage.getItem("USER")
  useEffect(() => {
    document.getElementById("loader").style.display = "block";
    if (
      sharedData.currentTicketNo === sharedData.commentTicketNo &&
      sharedData.ticketComment.length > 1
    ) {
      setDetail((prevData) => ({
        ...prevData,
        replyComment: sharedData.ticketComment,
      }));
    } else {
      setDetail((prevData) => ({
        ...prevData,
        replyComment: "",
      }));
    }
    FetchTicketDetail();

    const handleKeyDown = (event) => {
      const fieldName = event.target.name;

      if (
        (event.key === "Backspace" || event.key === "Delete") &&
        (fieldName === "targetDate" || fieldName === "tickleDate")
      ) {
        setTicketDates((prevData) => ({
          ...prevData,
          [fieldName]: null,
        }));
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [props]);

  const loadDates = (ticketData) => {
    setTicketDates((prevData) => ({
      ...prevData,
      targetDate:
        ticketData.TARGET_COMPLETION_DATE != null
          ? ticketData.TARGET_COMPLETION_DATE !== "0001-01-01T00:00:00" &&
            ticketData.TARGET_COMPLETION_DATE !== "0001-01-01T05:00:00"
            ? new Date(ticketData.TARGET_COMPLETION_DATE)
            : null
          : null,
      tickleDate:
        ticketData.TICKLE_DATE != null
          ? ticketData.TICKLE_DATE !== "0001-01-01T00:00:00" &&
            ticketData.TICKLE_DATE !== "0001-01-01T05:00:00"
            ? new Date(ticketData.TICKLE_DATE)
            : null
          : null,
      // createdDate:
      //   ticketDetail.CREATED_DATE != null
      //     ? moment(ticketDetail.CREATED_DATE).format("MM/DD/YYYY hh:mm:ss A")
      //     : "",
      // updatedDate:
      //   ticketDetail.LAST_UPDATE_DATE != null
      //     ? moment(ticketDetail.LAST_UPDATE_DATE).format(
      //         "MM/DD/YYYY hh:mm:ss A"
      //       )
      //     : "",
    }));
  };

  const FetchTicketDetail = () => {
    try {
      const data = new FormData();
      data.append("TicketNo", ticketNo);
      document.getElementById("loader").style.display = "block";
      fetch(setUrl("TICKETDETAIL", "LOADTICKETDETAIL", true), {
        method: "POST",
        body: data,
      })
        .then((response) => response.json())
        .then(async (data) => {
          const currentTicketData = data.TicketData[0];
          const ticketComments = data.CommentsData;
          setAttachmentFiles(data.AttachmentsData);
          if (data.TicketData.length > 0) {
            loadDates(currentTicketData);
            LoadCommentsHistoryData(data);
            await loadTicketDetail(currentTicketData);
            setDetail((prevInfo) => ({
              ...prevInfo,
              customerId: currentTicketData.ENTITY_SEQ_NUM,
              practiceName: currentTicketData.DESCRIPTION,
              noOfProvider: currentTicketData.NO_OF_PROVIDERS,
            }));

            setTicketDetail(currentTicketData);
          }
          document.getElementById("loader").style.display = "none";
        })
        .catch((error) => {
          document.getElementById("loader").style.display = "none";
        });
    } catch (e) {
      document.getElementById("loader").style.display = "none";
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const LoadCommentsHistoryData = (data) => {
    const currentTicketData = data.TicketData[0];
    const ticketComments = data.CommentsData;
    if (
      (data.AttachmentsData != null && data.AttachmentsData.length > 0) ||
      currentTicketData.ATTACHED_FILE
    ) {
      LoadTicketAttacments(currentTicketData);
      setTrigger((triggerInfo) => ({
        ...triggerInfo,
        ErrMsg: false,
      }));
    } else {
      setTrigger((triggerInfo) => ({
        ...triggerInfo,
        FileItems: false,
        ErrMsg: true,
      }));
    }

    setDetail((prevInfo) => ({
      ...prevInfo,
      fileSize: "30",
    }));

    if (data.CommentsData.length > 0) {
      setCommentsData(data.CommentsData);
      const commentsData = data.CommentsData;
      const filteredResolution = commentsData.filter(
        (data) => data.RESOLUTION === "Y",
      );
      if (filteredResolution != null && filteredResolution.length > 0) {
        setBoxes((prevInfo) => ({
          ...prevInfo,
          resolutionBtn: true,
        }));

        setDetail((prevInfo) => ({
          ...prevInfo,
          resolutionDesc: filteredResolution[0].RESOLUTION_TICKET_DES,
          resolutionTxt: filteredResolution[0].RESOLUTION_COMMENTS,
        }));
      }
    }

    setHistoryData(JSON.parse(data.HistoryData));
    if (
      currentTicketData.ATTACHED_FILE !== null &&
      currentTicketData.ATTACHED_FILE !== ""
    ) {
      const path = currentTicketData.ATTACHED_FILE;
      const splitPath = path.split("\\");
      const filePath = splitPath.slice(0, -1).join("\\");
      const fileName = splitPath[splitPath.length - 1];
      const fileData = {
        FILE_PATH: `${filePath}\\`,
        FILE_NAME: fileName,
      };
      setTaskhAttachmentFiles(fileData);
    }

    if (data.AttachmentsData != null) {
      setTrigger((triggerField) => ({
        ...triggerField,
        FileItems: true,
      }));
    }

    if (ticketComments.indexOf("isCheck") > -1) {
      AddCheckComment(ticketComments);
    }
    const resolutionData = ticketComments.find((el) => el.RESOLUTION === "Y");
    if (resolutionData != null) {
      setDetail((prevInfo) => ({
        ...prevInfo,
        resolutionDesc: resolutionData.RESOLUTION_TICKET_DES,
        resolutionTxt: resolutionData.RESOLUTION_COMMENTS,
      }));
      setBoxes((currBox) => ({
        ...currBox,
        resolutionBox: false,
      }));
    } else {
      setBoxes((currBox) => ({
        ...currBox,
        resolutionBox: true,
      }));
    }
    document.getElementById("loader").style.display = "none";
  };

  const AddCheckComment = (ticketCommentsArr) => {
    const newComments = [...ticketCommentsArr];
    for (const [index, value] of ticketCommentsArr.entries()) {
      newComments[index] = { ...newComments[index], isCheck: false };
    }
    setCommentsData(newComments);
  };

  const loadTicketDetail = async (ticketDetail) => {
    ResetControls(false);
    setBoxes((currBox) => ({
      ...currBox,
      select: false,
    }));

    const found = TICKET_TASK_FILTERS.STATUS_DATA.find(
      (obj) => obj.value === "I",
    );
    if (found) {
      const AlterStatus = [...StatusArray];
      const openIndex = AlterStatus.findIndex((el) => el.value === "O");
      if (openIndex) {
        AlterStatus[openIndex] = { ...AlterStatus[openIndex], label: "Open" };
        setStatusArray(AlterStatus);
      }

      const newItem = {
        label: "In Progress",
        value: "I",
        check: false,
      };
      setStatusArray((prevStatus) => [...prevStatus, newItem]);

      const resolvedIndex = AlterStatus.findIndex((el) => el.value === "R");
      if (resolvedIndex) {
        AlterStatus[resolvedIndex] = {
          ...AlterStatus[resolvedIndex],
          label: "Resolved",
        };
        setStatusArray(AlterStatus);
      }
    }
    const status = ticketDetail.STATUS;

    if (status === "K") {
      const found = TICKET_TASK_FILTERS.STATUS_DATA.find(
        (obj) => obj.value === "K",
      );
      if (found) {
        const statusObj = {
          label: "Reopened",
          value: "K",
        };
        setStatusArray((prevStatus) => [...prevStatus, statusObj]);
      }
      const updateArray = StatusArray.map((item) => {
        if (item.value === "O") {
          return { ...item, check: true };
        }
      });
      setStatusArray(updateArray);
    } else {
      const filterStatus = StatusArray.filter((item) => item.value !== "K");
      let statusFieldsData = filterStatus;

      setStatusArray(filterStatus);

      if (status === "R") {
        ResetControls(true);
        if (
          sessionStorage.type.toUpperCase() === "M" &&
          ticketDetail.TICKET_TYPE.toUpperCase() ===
            "TRAINING AND IMPLEMENTATION"
        ) {
          setBoxes((currBox) => ({
            ...currBox,
            notify: false,
            files: false,
            viewable: false,
            rplycmnt: false,
          }));
        }
      }
      if (
        ticketDetail.TICKET_TYPE.toUpperCase() === "TRAINING AND IMPLEMENTATION"
      ) {
        const filterStatus = statusFieldsData.filter(
          (item) => item.value !== "I",
        );
        statusFieldsData = filterStatus;
        setStatusArray(filterStatus);
        const updateStatus = [...statusFieldsData];
        const index = updateStatus.findIndex((el) => el.value === "O");
        if (ticketDetail.ISOVERDUE && ticketDetail.ISOVERDUE === "Y") {
          updateStatus[index] = { ...updateStatus[index], label: "Over Due" };
          setStatusArray(updateStatus);
        } else {
          updateStatus[index] = { ...updateStatus[index], label: "Pending" };
          setStatusArray(updateStatus);
        }
        const nextIndex = updateStatus.findIndex((el) => el.value === "R");
        updateStatus[nextIndex] = {
          ...updateStatus[nextIndex],
          label: "Completed",
        };
        setStatusArray(updateStatus);
      }
    }

    setDetail((prevInfo) => ({
      ...prevInfo,
      status: ticketDetail.STATUS != null ? ticketDetail.STATUS : "O",
      product:
        ticketDetail.PRODUCT_TYPE != null ? ticketDetail.PRODUCT_TYPE : "EHR",
      type: ticketDetail.TASK_TYPE != null ? ticketDetail.TASK_TYPE : "",
      typeCategory:
        ticketDetail.TICKET_CATEGORY != null
          ? ticketDetail.TICKET_CATEGORY
          : "",
      source:
        ticketDetail.TICKET_SOURCE != null ? ticketDetail.TICKET_SOURCE : "P",
    }));

    if (ticketDetail != null) {
      if (ticketDetail.PRACTICE_SETUP_LIST_SEQ_NUM) {
        setTrigger((triggerField) => ({
          ...triggerField,
          network: true,
          category: true,
          typeCategory: false,
          categoryDiv: true,
        }));
      } else if (
        ticketDetail.TICKET_TYPE.toUpperCase() === "TRAINING AND IMPLEMENTATION"
      ) {
        setTrigger((triggerField) => ({
          ...triggerField,
          network: false,
          category: false,
          categoryDiv: false,
          type: true,
        }));
      } else {
        setTrigger((triggerField) => ({
          ...triggerField,
          network: true,
          category: false,
          typeCategory: true,
          categoryDiv: true,
          type: false,
        }));
      }

      try {
        await LoadAssignees(
          ticketDetail.TICKET_TYPE.toUpperCase(),
          ticketDetail.ASSIGNEE,
        );

        if (ticketDetail.SUP_TICKET_TEAM_INFO_SEQ_NUM) {
          currentTeam = ticketDetail.SUP_TICKET_TEAM_INFO_SEQ_NUM;
          setDetail((prevInfo) => ({
            ...prevInfo,
            team: currentTeam,
          }));
        }

        ChangeTeam(ticketDetail.SUP_TICKET_TEAM_INFO_SEQ_NUM);

        if (ticketDetail.INTERNAL_ASSIGNEE) {
          setDetail((prevInfo) => ({
            ...prevInfo,
            internalAssignee: ticketDetail.INTERNAL_ASSIGNEE,
          }));
        }

        setDetail((prevInfo) => ({
          ...prevInfo,
          categoryName: ticketDetail.CATEGORY,
        }));
        if (ticketDetail.TICKET_TYPE.toUpperCase() === "IMPLEMENTATION") {
          setTrigger((triggerInfo) => ({
            ...triggerInfo,
            attachment: false,
          }));
        } else {
          setTrigger((triggerInfo) => ({
            ...triggerInfo,
            fileDiv: true,
          }));

          setTrigger((triggerInfo) => ({
            ...triggerInfo,
            attachment: status !== "R",
          }));
        }
      } catch (err) {
        console.log("error occurred now");
      }
    }
    setDetail((prevInfo) => ({
      ...prevInfo,
      reporter: ticketDetail.REPORTER_SHORT_NAME,
    }));
  };

  const ResetControls = (bit) => {
    setBoxes((currBox) => ({
      ...currBox,
      target: bit,
      tickle: bit,
      // comments: bit,
      resolutionBox: bit,
      notify: bit,
      files: bit,
      viewable: bit,
      select: bit,
    }));
  };

  const LoadTicketAttacments = (ticketDetail) => {
    if (ticketDetail.ATTACHED_FILE) {
      const img = ticketDetail.ATTACHED_FILE;
      const fileName = img.substring(img.lastIndexOf("\\") + 1);
      const printPath = img.substring(0, img.lastIndexOf("\\"));
      setDetail((prevInfo) => ({
        ...prevInfo,
        fileName,
        printPath,
      }));
    }
  };

  const ChangeTeam = (curTeam) => {
    const emptyData = {
      label: "-SELECT-",
      value: "",
    };

    if (
      TD_AssigneeDataArr.length > 0 &&
      curTeam &&
      curTeam !== "" &&
      curTeam !== 0
    ) {
      setInternalAssignees([]);
      const filterAssignee = TD_AssigneeDataArr.filter(
        (data) => data.Team === curTeam.toString(),
      );

      setInternalAssignees((prevAssignee) => [...prevAssignee, emptyData]);

      filterAssignee.forEach((item, key) => {
        const internalAssignee = {
          label: item.ShortName,
          value: item.Email,
        };
        setInternalAssignees((prevAssignee) => [
          ...prevAssignee,
          internalAssignee,
        ]);
      });
    } else {
      setInternalAssignees((prevAssignee) => [...prevAssignee, emptyData]);
    }
  };

  const LoadAssignees = async (type, currentAssignee) => {
    try {
      const formData = new FormData();
      formData.append("TicketNo", type);
      document.getElementById("loader").style.display = "block";
      const result = await fetch(setUrl("TICKETDETAIL", "LOADASSIGNEDDL"), {
        method: "POST",
        body: formData,
      });
      const response = await result.json();
      const assignee = {
        value: "",
        text: "- SELECT -",
        team: "",
        active: "",
      };
      TD_AssigneeIds.push(assignee);
      if (response && response.data) {
        const assignees = JSON.parse(response.data);

        if (assignees.length > 1 && currentAssignee != null) {
          const data = assignees.find((item) => item.Email === currentAssignee);

          if (data != null) {
            const curValue = {
              text: data.ShortName,
              value: data.Email,
            };
            setDetail((prevInfo) => ({
              ...prevInfo,
              assigneeValue: curValue != null ? curValue : null,
            }));
          }
        }

        TD_AssigneeDataArr = assignees;
        TD_AssigneeIds = [];
        assignees.forEach((assignee, key) => {
          const assigneeItem = {
            value: assignee.Email,
            text: assignee.ShortName,
            team: assignee.Team,
            active: assignee.Active,
          };
          if (assignee.value !== "" && assignee.text !== "-SELECT-") {
            TD_AssigneeIds.push(assigneeItem);
            setAssigneesOption((prevAssignee) => [
              ...prevAssignee,
              assigneeItem,
            ]);
          }
        });
      }

      const team = {
        value: "",
        label: "- SELECT -",
        email: "",
      };
      setInternalTeams((prevTeam) => [...prevTeam, team]);
      if (response && response.dataTeam) {
        const internalTeam = JSON.parse(response.dataTeam);
        internalTeam.forEach((team, key) => {
          const teamData = {
            value: team.SupportTeamId,
            label: team.Name,
            email: team.Email,
          };
          setInternalTeams((prevTeam) => [...prevTeam, teamData]);
        });
      }
      document.getElementById("loader").style.display = "none";
      return true;
    } catch (e) {
      document.getElementById("loader").style.display = "none";
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const UpdateCheckUpdated = (curVal) => {
    if (curVal != null) {
      setTrigger((triggerField) => ({
        ...triggerField,
        update: true,
      }));
    }
  };

  const DownloadTaskAttachment = async (filePath, downloadFileName, type) => {
    try {
      if (filePath) {
        const extension = downloadFileName.split(".").pop();
        const fullPath =
          `${filePath ?? ""}/${downloadFileName ?? ""}`.toLowerCase();
        document.getElementById("loader").style.display = "block";
        const response = await downloadDocument(fullPath, extension);

        if (response) {
          if (type === "image") {
            const Base64FileBytes = response.data.content;
            const mimeType = getMimeType(response.data.content);
            setImageInfo((prevInfo) => ({
              ...prevInfo,
              imageData: Base64FileBytes,
              fileName: downloadFileName,
              filePath,
              fileType: mimeType,
            }));

            setFileType(type);
            setImagePopup(!ImagePopup);
            document.getElementById("loader").style.display = "none";
            return;
          }

          downloadFileFromJsonBlob(response.data, downloadFileName);
        } else {
          DisplayMsg("2", "Failed to download file");
        }

        document.getElementById("loader").style.display = "none";
      }
    } catch (e) {
      DisplayMsg("2", "File not downloaded");
    }
  };

  const ShowPreviousData = () => {
    if (sharedData.SearchFrom === "Ticket") {
      navigate("/tickets");
    } else if (
      sharedData.CurrentTab === "clients" ||
      sharedData.SearchFrom === "clientDetail"
    ) {
      navigate("/client-detail", {
        state: {
          CurrentTab: sharedData.ClientDetailTab,
          ClientId: ticketDetail?.ENTITY_SEQ_NUM,
        },
      });
    } else if (sharedData.CurrentTab === "dashboard") {
      navigate("/dashboard");
    } else if (sharedData.CurrentTab === "inbox") {
      navigate("/inbox");
    } else if (sharedData.SearchFrom === "ticketDetail") {
      navigate("/client-detail");
    } else if (sharedData.CurrentTab === "tickets") {
      navigate("/tickets");
    } else if (sharedData.SearchFrom === "A") {
      sharedData.SearchFrom = "A";
      navigate("/tickets");
    } else if (
      sharedData.CurrentTab === "clients" ||
      sharedData.SearchFrom === "clientDetail"
    ) {
      navigate("/client-detail", {
        state: {
          CurrentTab: sharedData.ClientDetailTab,
          ClientId: ticketDetail?.ENTITY_SEQ_NUM,
        },
      });
    } else if (sharedData.CurrentTab === "ticketDetail") {
      navigate("/tickets");
    }
  };

  const showComments = () => {
    setBoxes((currBox) => ({
      ...currBox,
      resolution: false,
      history: false,
      comments: true,
    }));
  };

  const showHistory = () => {
    setBoxes((currBox) => ({
      ...currBox,
      resolution: false,
      history: true,
      comments: false,
    }));
  };

  const showResolution = () => {
    if (CommentsData == null || CommentsData.length < 1) {
      setBoxes((currBox) => ({
        ...currBox,
        resolutionBox: true,
      }));
    }

    // if (CommentsData != null && CommentsData.length > 0) {
    //   let check = CommentsData.filter(
    //     (item) => item.RESOLUTION_COMMENTS !== ""
    //   );
    //   if (check) {
    //   }
    // }

    setBoxes((currBox) => ({
      ...currBox,
      resolution: true,
      history: false,
      comments: false,
    }));
  };

  const ResolutionCheck = CommentsData.filter((row) => row.RESOLUTION === "Y");

  const updateComments = (data) => {
    const newComments = [...CommentsData];
    const indexVal = newComments.findIndex(
      (el) => el.SEQ_NUM === data.comment_seqNumb,
    );
    newComments[indexVal] = {
      ...newComments[indexVal],
      isCheck: data.event.target.checked,
    };

    for (const [index] of CommentsData.entries()) {
      if (index !== indexVal) {
        newComments[index] = {
          ...newComments[index],
          isCheck: !data.event.target.checked,
        };
      }
    }
    setCommentsData(newComments);
  };

  const ManageResolutionState = (data) => {
    if (data.event.target.checked === true) {
      setResolutionData(data);
      updateComments(data);

      setBoxes((currBox) => ({
        ...currBox,
        resolution: true,
        history: false,
        comments: false,
      }));
    } else {
      UnCheckComments(data);
      setResolutionData(data);
    }
  };

  const setResolutionData = (data) => {
    if (data.event.target.checked) {
      showResolution();
      setBoxes((currBox) => ({
        ...currBox,
        resolution: false,
      }));
      if (data.comment !== "null") {
        const comments = DecodeString(data.comments);
        setDetail((prevInfo) => ({
          ...prevInfo,
          resolutionTxt: comments,
          resolutionSeqNum: data.resolution_seqNumb,
          commentSeqNum: data.comment_seqNumb,
          resolutionDesc: ticketDetail?.COMMENTS,
        }));
        setBoxes((currBox) => ({
          ...currBox,
          resolutionBox: false,
        }));
        showResolution();
      }
    } else {
      setBoxes((currBox) => ({
        ...currBox,
        resolutionBox: true,
      }));
      setDetail((prevInfo) => ({
        ...prevInfo,
        resolutionTxt: "",
        resolutionSeqNum: "",
        commentSeqNum: "",
        resolutionDesc: "",
      }));
    }
  };

  const DecodeString = (comment) => {
    const str = decodeURIComponent(comment);
    return str.replaceAll("<br>", "\n");
  };

  const UnCheckComments = (data) => {
    const newComments = [...CommentsData];
    const indexVal = newComments.findIndex(
      (el) => el.SEQ_NUM === data.comment_seqNumb,
    );
    newComments[indexVal] = {
      ...newComments[indexVal],
      isCheck: data.event.target.checked,
    };
    setCommentsData(newComments);
  };

  const AlterTicketData = (dateVal, name) => {
    if (dateVal != null) {
      setTicketDates((prevData) => ({
        ...prevData,
        [name]: new Date(dateVal),
      }));
    } else {
      setTicketDates((prevData) => ({
        ...prevData,
        [name]: null,
      }));
    }

    UpdateCheckUpdated(true);
  };

  const AlterDateValues = (e) => {
    keyRestrict(e, "0123456789");
    if (e.target.value.length <= 10) {
      setDetail((dateInfo) => ({
        ...dateInfo,
        [e.target.name]: e.target.value,
      }));
    }
  };

  const updateTicket = async () => {
    try {
      if (commentFiles.length > 0) {
        if (Detail.replyComment.length < 1) {
          DisplayMsg(
            "2",
            "Please add comment in comment box to upload comment file",
          );
          return;
        }
      }

      if (Trigger.update) {
        let assigneeFlag = 0;
        let InternalAssigneeFlag = 0;
        let teamAssigneeFlag = 0;

        const detailTicket = ticketDetail;

        const oldassignee = detailTicket.ASSIGNEE
          ? detailTicket.ASSIGNEE
          : null;
        let newassigneee = null;

        const oldInternalAssignee = detailTicket.INTERNAL_ASSIGNEE
          ? detailTicket.INTERNAL_ASSIGNEE
          : "";
        let newInternalAssignee = null;

        const oldTeamName = detailTicket.TEAMNAME ? detailTicket.TEAMNAME : "";
        const oldTeamAssignee = detailTicket.ASSIGNEETEAM
          ? detailTicket.ASSIGNEETEAM
          : "";
        const oldTeamSeqNum = detailTicket.SUP_TICKET_TEAM_INFO_SEQ_NUM
          ? detailTicket.SUP_TICKET_TEAM_INFO_SEQ_NUM
          : "";
        let NewTeamAssigneee = null;
        let newTeamSeqNum = null;
        let newProductType = null;
        let oldProduct = null;
        let newTicketSource = null;
        let oldTicket = null;

        oldTicket = detailTicket.TICKET_SOURCE
          ? detailTicket.TICKET_SOURCE
          : "";
        oldProduct = detailTicket.PRODUCT_TYPE ? detailTicket.PRODUCT_TYPE : "";
        const ticketNo = detailTicket.TICKET_NO;
        const userReplyCmnt =
          Detail.replyComment != null ? Detail.replyComment : "";
        const viewableBy = Detail.viewable;
        const notifyUser = Detail.notify == null ? false : Detail.notify;
        if (notifyUser && !userReplyCmnt) {
          DisplayMsg("2", "Please add comments to notify user");
          return;
        }

        let statusFlag = 0;
        let tickleFlag = 0;
        const oldstatus = detailTicket.STATUS;
        let newstatus = Detail.status == null ? "O" : Detail.status;

        if (newstatus.toUpperCase() === "OPEN") {
          newstatus = "O";
        } else if (newstatus.toUpperCase() === "IN PROGRESS") {
          newstatus = "I";
        } else if (newstatus.toUpperCase() === "PENDING ON CLIENT") {
          newstatus = "Q";
        } else if (newstatus.toUpperCase() === "RESOLVED") {
          newstatus = "R";
        } else if (newstatus.toUpperCase() === "REOPENED") {
          newstatus = "K";
        }

        newTicketSource = Detail.source ? Detail.source : oldTicket;
        newProductType = Detail.product ? Detail.product : oldProduct;

        newassigneee =
          Detail.assigneeValue !== null && Detail.assigneeValue !== ""
            ? Detail.assigneeValue.value
            : oldassignee;
        newInternalAssignee = Detail.internalAssignee
          ? Detail.internalAssignee
          : "";
        newTeamSeqNum = Detail.team ? Detail.team : "";
        NewTeamAssigneee = Detail.teamEmail ? Detail.teamEmail : "";
        const teamName = Detail.teamText ? Detail.teamText : "";

        const oldTargetCompletionDate =
          ticketDetail?.TARGET_COMPLETION_DATE !== null
            ? moment(ticketDetail?.TARGET_COMPLETION_DATE).format("MM/DD/yyyy")
            : "";

        const newTargetCompletionDate =
          TicketDates.targetDate == null
            ? ""
            : moment(TicketDates.targetDate).format("MM/DD/yyyy");
        const tickleChangeOld =
          ticketDetail.TICKLE_DATE !== null
            ? moment(ticketDetail.TICKLE_DATE).format("MM/DD/yyyy")
            : "";
        const tickelDateNew =
          TicketDates.tickleDate == null
            ? ""
            : moment(TicketDates.tickleDate).format("MM/DD/yyyy");
        if (
          tickelDateNew !== "" &&
          tickelDateNew <= moment(new Date(), "MM/DD/yyyy")
        ) {
          DisplayMsg("2", "Only Future Tickle Date is allowed...");
          return;
        }

        document.getElementById("loader").style.display = "block";
        let targetDateFlag = 0;
        if (oldTargetCompletionDate !== newTargetCompletionDate) {
          targetDateFlag = 1;
        }

        const oldTaskType = detailTicket.TASK_TYPE || "";
        const newTaskType = Detail.type != null ? Detail.type : "";
        let taskTypeChngeFlag = 0;
        if (oldTaskType !== newTaskType) {
          taskTypeChngeFlag = 1;
        }

        let categoryChngeFlag = 0;
        let ticketSourceChngeFlag = 0;
        let producttypeChangeFlag = 0;
        let oldCategory = "";
        let newCategory = "";
        if (
          !detailTicket.PRACTICE_SETUP_LIST_SEQ_NUM &&
          detailTicket.TICKET_TYPE.toUpperCase() !==
            "TRAINING AND IMPLEMENTATION"
        ) {
          oldCategory = detailTicket.TICKET_CATEGORY
            ? detailTicket.TICKET_CATEGORY
            : "";
          oldCategory = oldCategory === "undefined" ? "" : oldCategory;
          newCategory = Detail.typeCategory != null ? Detail.typeCategory : "";
        }
        if (oldTicket !== newTicketSource && oldTicket !== "") {
          ticketSourceChngeFlag = 1;
        }

        if (oldProduct !== newProductType && oldProduct !== "") {
          producttypeChangeFlag = 1;
        }
        if (oldCategory !== newCategory) {
          categoryChngeFlag = 1;
        }
        if (
          userReplyCmnt === "" &&
          tickelDateNew === tickleChangeOld &&
          newstatus === oldstatus &&
          newassigneee === oldassignee &&
          newInternalAssignee === oldInternalAssignee &&
          newTeamSeqNum === oldTeamSeqNum &&
          oldTargetCompletionDate === newTargetCompletionDate &&
          oldCategory === newCategory &&
          oldTaskType === newTaskType &&
          oldTicket === newTicketSource &&
          oldProduct === newProductType
        ) {
          DisplayMsg("2", "Kindly Perform Some action To Update The Ticket...");
          return;
        }

        if (newstatus !== oldstatus) {
          statusFlag = 1;
        }
        if (tickelDateNew !== tickleChangeOld) {
          tickleFlag = 1;
        }
        if (newassigneee !== oldassignee) {
          assigneeFlag = 1;
        }
        if (newInternalAssignee !== oldInternalAssignee) {
          InternalAssigneeFlag = 1;
        }
        if (newTeamSeqNum !== oldTeamSeqNum) {
          teamAssigneeFlag = 1;
        }
        const userName = sessionStorage.USER;
        const formdata = new FormData();

        if (userReplyCmnt && commentFiles.length > 0) {
          for (var i = 0; i < commentFiles.length; i++) {
            formdata.append(`commentAttachment${i}`, commentFiles[i]);
          }
        }

        if (Detail.attachments) {
          for (var i = 0; i < Detail.attachments.length; i++) {
            formdata.append(`IMAGEFILE${i}`, Detail.attachments[i]);
          }
        }
        formdata.append(
          "USERSEQNUM",
          sessionStorage.SEQ_NUM ? sessionStorage.SEQ_NUM : "",
        );
        formdata.append("PRODUCTYPE", newProductType);
        formdata.append("OLDPRODUCTYPE", oldProduct);
        formdata.append("TICKETSOURCE", newTicketSource);
        formdata.append("OLDTICKETSOURCE", oldTicket);
        formdata.append("PRODUCTYPECHANGE", producttypeChangeFlag);
        formdata.append("TICKETSOURCECHANGE", ticketSourceChngeFlag);
        formdata.append("TICKETNO", ticketNo);
        formdata.append("USERREPLYCMNT", encodeURIComponent(userReplyCmnt));
        formdata.append("VIEWABLEBY", viewableBy);
        formdata.append("STATUSCHNGEFLAG", statusFlag);
        formdata.append("OLDSTATUS", oldstatus);
        formdata.append("NEWSTATUS", newstatus);
        formdata.append("ASSIGNEECHNGEFLAG", assigneeFlag);
        formdata.append("OLDASSIGNEE", oldassignee);
        formdata.append("NEWASSIGNEEE", newassigneee);
        formdata.append("INTERNALASSIGNEECHNGEFLAG", InternalAssigneeFlag);
        formdata.append("OLDINTERNALASSIGNEE", oldInternalAssignee);
        formdata.append("NEWINTERNALASSIGNEE", newInternalAssignee);
        formdata.append("TEAMASSIGNEECHNGEFLAG", teamAssigneeFlag);
        formdata.append("OLDTEAMASSIGNEE", oldTeamAssignee);
        formdata.append("NEWTEAMASSIGNEEE", NewTeamAssigneee);
        formdata.append("OLDTEAMSEQNUM", oldTeamSeqNum);
        formdata.append("NEWTEAMSEQNUM", newTeamSeqNum);
        formdata.append("TEAMNAME", teamName);
        formdata.append("OLDTEAMNAME", oldTeamName);
        formdata.append("NOTIFYUSER", notifyUser);
        formdata.append("USERNAME", userName);
        formdata.append("OLDTARGETDATE", oldTargetCompletionDate);
        formdata.append("NEWTARGETDATE", newTargetCompletionDate);
        formdata.append("OLDTICKEL_DATE", tickleChangeOld);
        formdata.append("TICKEL_DATE", tickelDateNew);
        formdata.append("TICKEL_DATE_FLAG", tickleFlag);
        formdata.append("TARGETDATEFLAG", targetDateFlag);
        formdata.append("OLDCATEGORY", oldCategory);
        formdata.append("NEWCATEGORY", newCategory);
        formdata.append("CATEGORYFLAG", categoryChngeFlag);
        formdata.append("OLDTASKTYPE", oldTaskType);
        formdata.append("NEWTASKTYPE", newTaskType);
        formdata.append("TASKTYPEFLAG", taskTypeChngeFlag);
        formdata.append("docStorageName", DOCUMENT_STORAGE);
        document.getElementById("loader").style.display = "block";

        const result = await fetch(
          setUrl("TICKETDETAIL", "UPDATETICKET", true),
          {
            method: "POST",
            body: formdata,
          },
        );
        const response = await result.json();
        if (response.status === true) {
          document.getElementById("loader").style.display = "none";
          response.Message =
            taskType === false
              ? "Ticket updated successfully"
              : "Task updated Successfully";
          DisplayMsg("1", response.Message);
          FilesContainer.Files = "undefined";
          setDetail((prevInfo) => ({
            ...prevInfo,
            replyComment: "",
            files: "",
            attachments: null,
            notify: false,
          }));
          setTrigger((triggerField) => ({
            ...triggerField,
            ticketUpdate: true,
            update: false,
          }));
          setCommentFiles([]);
          setMyFiles([]);
          RefreshTickeDetail();
        } else {
          document.getElementById("loader").style.display = "none";
          DisplayMsg("2", response.Message);
        }

        dispatch(setTicketComment(""));
        // dispatch(setUserName(""));
        dispatch(setCurrentTicketNo(""));
      } else {
        DisplayMsg(
          "2",
          "Please update ticket field to Perform update operation",
        );
      }
    } catch (e) {
      document.getElementById("loader").style.display = "none";
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const SaveResolution = async () => {
    try {
      if (boxes.resolutionBox === false) {
        const resolutionTxt =
          Detail.resolutionTxt != null ? Detail.resolutionTxt : "";
        const resolutionDesc =
          Detail.resolutionDesc != null ? Detail.resolutionDesc : "";
        if (resolutionTxt && resolutionDesc) {
          document.getElementById("loader").style.display = "block";
          const comment_seq_num =
            Detail.commentSeqNum != null ? Detail.commentSeqNum : "";
          const resolution_seq_num =
            Detail.resolutionSeqNum != null ? Detail.resolutionSeqNum : "";

          const resolutionInfo = new FormData();
          resolutionInfo.append("TICKETNO", ticketNo);
          resolutionInfo.append("COMMENT_SEQ_NUM", comment_seq_num);
          resolutionInfo.append("RESOLUTION_SEQ_NUM", resolution_seq_num);
          resolutionInfo.append("USERCOMMENTS", resolutionTxt);
          resolutionInfo.append("TICKETDESCRIPTION", resolutionDesc);
          const result = await fetch(
            setUrl("TICKETDETAIL", "SAVETICKETRESOLUTION", true),
            {
              method: "POST",
              body: resolutionInfo,
            },
          );
          const response = await result.json();
          if (response.status === true) {
            DisplayMsg("1", response.Message);
            FetchTicketDetail();
          } else {
            DisplayMsg("2", response.Message);
          }
        } else {
          DisplayMsg("2", "Please enter resolution description and text...");
        }
      }
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const HandleImage = (childData) => {
    setImagePopup(childData);
    setImageData("");
  };
  const ShowClientDetail = (customerId) => {
    dispatch(setSearchFrom("ticketDetail"));
    dispatch(setCurrentTicketNo(ticketNo));
    dispatch(setCurrentClientId(customerId));
    navigate("/client-detail", {
      state: {
        ClientId: customerId,
        CurrentTab: "ClientDetail",
      },
    });
  };

  const ShowMerge = () => {
    dispatch(setMergeTicketCustomerId(ticketDetail?.ENTITY_SEQ_NUM));
    setTrigger((triggerInfo) => ({
      ...triggerInfo,
      Merge: true,
    }));
  };

  const HandleMergeTicket = (childData) => {
    setTrigger((triggerInfo) => ({
      ...triggerInfo,
      Merge: childData,
    }));
    document.getElementById("loader").style.display = "none";
  };

  const ToggleBowserInfo = () => {
    setTrigger((triggerInfo) => ({
      ...triggerInfo,
      browser: !Trigger.browser,
    }));
  };

  const RefreshTickeDetail = () => {
    document.getElementById("loader").style.display = "block";
    setTrigger((triggerField) => ({
      ...triggerField,
      update: false,
    }));

    setDetail((prevData) => ({
      ...prevData,
      replyComment: "",
    }));
    setCommentFiles([]);
    setMyFiles([]);
    setInternalAssignees([]);
    setInternalTeams([]);
    setAssigneesOption([]);
    ChangeTeam(Detail.team);
    FetchTicketDetail();
  };

  const IsFileSizeValid = (file) => {
    if (file) {
      const filesizeMb = (file.size / (1024 * 1024)).toFixed(2);
      return Math.round(parseFloat(filesizeMb)) <= 30;
    }
  };

  const formatDateInTimeZone = (date, timeZone) =>
    new Date(
      new Intl.DateTimeFormat("en-US", {
        timeZone,
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      }).format(date),
    );

  const FieldData = (textField, type) => {
    const curValue = textField.fieldValue;
    if (type === "attachments") {
      let check = true;
      check = CheckFileSize(textField.target.files);
      if (check) {
        setDetail((prevData) => ({
          ...prevData,
          attachments: textField.target.files,
        }));
        if (textField.target.files.length > 0) {
          setTrigger((triggerField) => ({
            ...triggerField,
            update: true,
          }));
        }
      }
    } else if (textField.fieldName === "team") {
      if (textField.fieldValue === "") {
        const obj = [
          {
            label: "- Select -",
            value: "",
          },
        ];
        setInternalAssignees(obj);

        setDetail((prevInfo) => ({
          ...prevInfo,
          team: "",
          teamText: "- Select- ",
          teamEmail: "",
          internalAssignee: "",
        }));
      } else {
        ChangeTeam(textField.fieldValue);
        InternalTeams.forEach((team) => {
          if (team.value === textField.fieldValue) {
            setDetail((prevInfo) => ({
              ...prevInfo,
              team: team.value,
              teamText: team.label,
              teamEmail: team.email,
            }));
          }
        });
      }
    } else if (textField.fieldName === "replyComment") {
      dispatch(setCommentUserEmail(textField.fieldValue));
      dispatch(setUserEmail(sessionStorage.getItem("USER")));
      dispatch(setCommentTicketNo(ticketNo));
      dispatch(setTicketComment(curValue));

      setDetail((prevData) => ({
        ...prevData,
        replyComment: textField.fieldValue,
      }));
    } else if (textField.fieldName === "typeCategory") {
      const categoryValue = textField.fieldValue;

      setDetail((prevData) => ({
        ...prevData,
        typeCategory: categoryValue,
      }));

      if (categoryValue === "ENHANCEMENT") {
        setTicketDates((prevData) => ({
          ...prevData,
          targetDate: null,
        }));
      } else {
        const filterCategory = TICKET_TASK_FILTERS.TICKET_CATEGORIES.find(
          (item) => item.value === textField.fieldValue,
        );
        if (filterCategory != null && filterCategory.dayCount > 0) {
          const dayCount = filterCategory.dayCount;

          // Current date in America/New_York timezone
          const currentDateInET = new Date(
            new Date().toLocaleString("en-US", {
              timeZone: "America/New_York",
            }),
          );

          let targetDate = new Date(currentDateInET);
          let addedDays = 0;

          // Add dayCount business days
          while (addedDays < dayCount) {
            targetDate.setDate(targetDate.getDate() + 1);
            const dayOfWeek = targetDate.getDay(); // 0 = Sunday, 6 = Saturday
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
              addedDays++;
            }
          }

          // Final adjustment: if target date is weekend, move to next Monday
          while (targetDate.getDay() === 0 || targetDate.getDay() === 6) {
            targetDate.setDate(targetDate.getDate() + 1);
          }

          setTicketDates((prevData) => ({
            ...prevData,
            targetDate,
          }));
        }
      }
    } else {
      setDetail((prevData) => ({
        ...prevData,
        [textField.fieldName]: textField.fieldValue,
      }));
    }

    UpdateCheckUpdated(curValue);
  };

  const UpdateTicketInfo = (e) => {
    const { name } = e.target;
    const { value } = e.target;
    setDetail((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
    UpdateCheckUpdated(value);
  };

  const FieldValue = (fieldName) => {
    let fieldValue;
    if (fieldName === "targetDate" || fieldName === "tickleDate") {
      fieldValue = Detail[fieldName] != null ? dayjs(Detail[fieldName]) : "";
    } else {
      fieldValue = Detail[fieldName] != null ? Detail[fieldName] : "";
    }
    return fieldValue;
  };

  const cellPracticeName = (detail) => {
    if (detail?.ACTIVE_FLAG && detail?.ACTIVE_FLAG.toUpperCase() !== "Y") {
      return (
        <span className="practice-name" style={{ color: "red" }}>
          {" "}
          {detail?.DESCRIPTION}
        </span>
      );
    }
    if (detail?.ACCOUNT_TYPE && detail?.ACCOUNT_TYPE.toUpperCase() === "LIVE") {
      return (
        <span className="practice-name" style={{ color: "green" }}>
          {" "}
          {detail?.DESCRIPTION}
        </span>
      );
    }
    return (
      <span className="practice-name" style={{ color: "orange" }}>
        {" "}
        {detail?.DESCRIPTION}
      </span>
    );
  };

  const CalculateHeight = () => {
    let height = "";

    if (CommentsData.length < 4) {
      height = "auto";
    } else {
      height = "500px";
    }

    return height;
  };

  const AlterAssignee = (filter) => {
    const data = TD_AssigneeIds.slice();
    return filterBy(data, filter);
  };

  const AlterComboBoxData = (event) => {
    let data;
    const curVal = event.target.value;
    setDetail((prevData) => ({
      ...prevData,
      assigneeValue: curVal != null ? curVal : null,
    }));
    data = curVal == null ? true : curVal;
    UpdateCheckUpdated(data);
  };

  const AlterAssigneeData = (event) => {
    const selectOption = {
      value: "",
      text: "- SELECT -",
      team: "",
      active: "Y",
    };

    let newAssignee =
      event.filter.value.length > 1
        ? AlterAssignee(event.filter)
        : TD_AssigneeIds.slice();

    newAssignee = newAssignee.filter((item) => item.value !== "");

    const updatedAssignee = [selectOption, ...newAssignee];
    setAssigneesOption(updatedAssignee);
  };

  const SortedData = useMemo(() => {
    const selectOption = AssigneeList.find((item) => item.value === "");
    const otherOptions = AssigneeList.filter((item) => item.value !== "");

    otherOptions.sort((a, b) => {
      if (a.active === "Y" && b.active !== "Y") return -1;
      if (a.active !== "Y" && b.active === "Y") return 1;
      return 0;
    });

    return selectOption ? [selectOption, ...otherOptions] : otherOptions;
  }, [AssigneeList]);

  const ItemRender = (li, itemProps) => {
    const { dataItem } = itemProps;
    const combinedClassName = `${li.props.className} ${
      dataItem.active === "N" ? "bg-yellow-500" : ""
    }`;
    return React.cloneElement(li, {
      className: combinedClassName,
    });
  };

  return (
    <>
      {ImagePopup && (
        <AttachImage
          parentCallback={HandleImage}
          data={ImageInfo}
          fileType={fileType}
        />
      )}

      {Trigger.Merge && (
        <div className="table-panel-body">
          <MergeTicketGrid parentCallback={HandleMergeTicket} />
        </div>
      )}

      <MainLayout>
        <div role="tabpanel" className="tab-pane detailTask" id="ticketLink">
          <div className="key-card">
            <div className="row key-header flex-center">
              <div className="col-md-2 col-sm-3">
                <div>
                  <h3>
                    <i className="fa fa-key" />
                    {taskType ? "Task" : "Ticket"}
                    :&nbsp;
                    <span className="txtReadOnly ticketDetailType">
                      {ticketNo}
                    </span>
                  </h3>
                </div>
              </div>
              <div className="col-md-3 col-sm-3">
                <div>
                  <h3>
                    <i className="fa fa-user-plus" />
                    {Detail.noOfProvider >= 3 && (
                      <span className="text-lg text-red-500">*</span>
                    )}{" "}
                    Customer Id:&nbsp;
                    <span
                      className="txtReadOnly ticketDetailType cursor-pointer"
                      onClick={() =>
                        ShowClientDetail(ticketDetail?.ENTITY_SEQ_NUM)
                      }
                    >
                      {ticketDetail?.ENTITY_SEQ_NUM}
                    </span>
                  </h3>
                </div>
              </div>
              <div className="col-md-5 col-sm-3 text-left">
                <div>
                  <h3>
                    <i className="fa fa-tasks" />
                    Practice Name:&nbsp;
                    <span className="practice-name">
                      {Detail.practiceName != null &&
                      Detail.practiceName.length > 0
                        ? cellPracticeName(ticketDetail)
                        : ""}
                    </span>
                  </h3>
                </div>
              </div>

              <div className="col-md-2 col-sm-3">
                <input
                  type="button"
                  className="btnLinkGreen btnUpdate"
                  value="Back To List"
                  onClick={() => ShowPreviousData()}
                />
              </div>
            </div>
            <div className="row key-body">
              <div className="col-md-4 col-sm-4 key-left-section">
                <div className="row">
                  <div className="col-md-6 col-sm-6">
                    <div className="field-container">
                      <label className="field-placeholder font-medium">
                        Created:
                      </label>

                      <p className="txtReadOnly fieldReadOnly">
                        {ticketDetail?.CREATED_DATE ? (
                          moment(ticketDetail.CREATED_DATE).format(
                            "MM/DD/YYYY hh:mm:ss A",
                          )
                        ) : (
                          <span>&nbsp;</span>
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="field-container">
                      <label className="field-placeholder font-medium">
                        Updated:
                      </label>

                      <p className="txtReadOnly fieldReadOnly">
                        {ticketDetail?.LAST_UPDATE_DATE ? (
                          moment(ticketDetail.LAST_UPDATE_DATE).format(
                            "MM/DD/YYYY hh:mm:ss A",
                          )
                        ) : (
                          <span>&nbsp;</span>
                        )}
                      </p>
                    </div>
                  </div>

                  {Trigger.categoryDiv ? (
                    <div className="col-md-6 col-sm-6">
                      <div className="field-container">
                        <label className="field-placeholder font-medium">
                          Category:
                        </label>
                        {!Trigger.typeCategory && (
                          <p className="txtReadOnly fieldReadOnly">
                            {ticketDetail?.CATEGORY || <span>&nbsp;</span>}
                          </p>
                        )}
                        {Trigger.typeCategory && (
                          <DropDownField
                            id="typeCategory"
                            classDiv={false}
                            label={false}
                            required={false}
                            disabled={boxes.select}
                            options={TICKET_TASK_FILTERS.TICKET_CATEGORIES}
                            value={FieldValue("typeCategory")}
                            ReceivedTextData={FieldData}
                          />
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="col-md-6 col-sm-6 d-none">&nbsp;</div>
                  )}

                  <div className="col-md-6 col-sm-6">
                    <DropDownField
                      id="product"
                      classDiv
                      bold
                      label="Product Type:"
                      required={false}
                      disabled={boxes.select}
                      options={TICKET_TASK_FILTERS.PRODUCTS}
                      value={FieldValue("product")}
                      ReceivedTextData={FieldData}
                    />
                  </div>

                  <div className="col-md-6 col-sm-6">
                    <DropDownField
                      id="status"
                      classDiv
                      bold
                      label="Status"
                      required={false}
                      disabled={boxes.select}
                      options={StatusArray}
                      value={FieldValue("status")}
                      ReceivedTextData={FieldData}
                    />
                  </div>

                  <div className="col-md-6 col-sm-6">
                    <ReadField
                      label="Priority:"
                      value={ticketDetail?.PRIORITY}
                    />
                  </div>

                  {Trigger.type && (
                    <div className="col-md-6 col-sm-6">
                      <DropDownField
                        id="type"
                        classDiv
                        bold
                        label="Type:"
                        required={false}
                        disabled={boxes.select}
                        options={TICKET_TASK_FILTERS.TYPES}
                        value={FieldValue("type")}
                        ReceivedTextData={FieldData}
                      />
                    </div>
                  )}

                  <div className="col-md-6 col-sm-6">
                    <DropDownField
                      id="source"
                      classDiv
                      bold
                      label="Ticket Source:"
                      required={false}
                      disabled={boxes.select}
                      options={TICKET_TASK_FILTERS.SOURCES}
                      value={FieldValue("source")}
                      ReceivedTextData={FieldData}
                    />
                  </div>

                  <div className="col-md-6 col-sm-6">
                    <div className="field-container">
                      <label className="field-placeholder font-medium">
                        Reporter:
                      </label>
                      <p className="txtReadOnly fieldReadOnly">
                        {ticketDetail?.REPORTER_SHORT_NAME || (
                          <span>&nbsp;</span>
                        )}
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-6" id="comboxField">
                    <div className="ml-2">
                      <div className="field-container">
                        <label className="field-placeholder font-medium">
                          Assignee:
                        </label>
                        <div className="comboBox-container">
                          <ComboBox
                            className="field-input custom-combobox"
                            data={SortedData}
                            value={
                              FieldValue("assigneeValue") === ""
                                ? null
                                : FieldValue("assigneeValue")
                            }
                            name="assigneeValue"
                            textField="text"
                            disabled={boxes.select}
                            filterable
                            popupSettings={{
                              height: "200px",
                              className: "custom-dropdownDetail",
                            }}
                            itemRender={ItemRender}
                            style={{ width: "100%", fontSize: "4px" }}
                            onFilterChange={AlterAssigneeData}
                            onChange={AlterComboBoxData}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-6">
                    <div className="textBoxValidate field-container overflow-visible">
                      <label className="field-placeholder font-medium">
                        Target Date:
                      </label>

                      <DatePicker
                        value={
                          TicketDates.targetDate
                            ? dayjs(TicketDates.targetDate)
                            : null
                        }
                        onChange={(data) => AlterTicketData(data, "targetDate")}
                        name="targetDate"
                        disabled={boxes.target}
                        format="MM/DD/YYYY"
                        placeholder="MM/DD/YYYY"
                        onKeyDown={(e) => AlterDateValues(e)}
                      />
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-6">
                    <DropDownField
                      id="team"
                      classDiv
                      bold
                      label="Internal Team:"
                      required={false}
                      disabled={boxes.select}
                      options={InternalTeams}
                      value={FieldValue("team")}
                      ReceivedTextData={FieldData}
                    />
                  </div>

                  <div className="col-md-6 col-sm-6">
                    <div className="textBoxValidate field-container overflow-visible">
                      <label className="field-placeholder font-medium">
                        Tickle Date:
                      </label>

                      <DatePicker
                        value={
                          TicketDates.tickleDate
                            ? dayjs(TicketDates.tickleDate)
                            : null
                        }
                        onChange={(data) => AlterTicketData(data, "tickleDate")}
                        name="tickleDate"
                        disabled={boxes.tickle}
                        format="MM/DD/YYYY"
                        placeholder="MM/DD/YYYY"
                        onKeyDown={(e) => AlterDateValues(e)}
                      />
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-6">
                    <DropDownField
                      id="internalAssignee"
                      bold
                      classDiv
                      label="Internal Assignee:"
                      required={false}
                      disabled={boxes.select}
                      options={InternalAssignees}
                      value={FieldValue("internalAssignee")}
                      ReceivedTextData={FieldData}
                    />
                  </div>

                  <div className="col-md-6 col-sm-6">
                    <div className="field-container">
                      <label className="field-placeholder font-medium">
                        Implementation Manager:
                      </label>
                      <p className="txtReadOnly fieldReadOnly">
                        {ticketDetail?.IMP_MANAGER_SHORT_NAME || (
                          <span>&nbsp;</span>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                {Trigger.network && (
                  <div className="text-right mr-3">
                    {Trigger.browser ? (
                      <FontAwesomeIcon
                        className="fa-thin"
                        icon="caret-down"
                        size="xl"
                        onClick={() => ToggleBowserInfo()}
                      />
                    ) : (
                      <FontAwesomeIcon
                        className="fa-thin"
                        icon="caret-up"
                        size="xl"
                        onClick={() => ToggleBowserInfo()}
                      />
                    )}
                  </div>
                )}
                <div>
                  {Trigger.network && Trigger.browser ? (
                    <>
                      <div className="row">
                        <div className="col-md-6 col-sm-6">
                          <div className="field-container">
                            <label className="field-placeholder font-medium">
                              Browser Type:
                            </label>
                            <p className="txtReadOnly fieldReadOnly">
                              {ticketDetail?.BROWSER_TYPE || (
                                <span>&nbsp;</span>
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-6">
                          <div className="field-container">
                            <label className="field-placeholder font-medium">
                              Download Speed:
                            </label>
                            <p className="txtReadOnly fieldReadOnly">
                              {ticketDetail?.DOWNLOAD_SPEED || (
                                <span>&nbsp;</span>
                              )}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6 col-sm-6">
                          <div className="field-container">
                            <label className="field-placeholder font-medium">
                              Upload Speed:
                            </label>

                            <p className="txtReadOnly fieldReadOnly">
                              {ticketDetail?.UPLOAD_SPEED || (
                                <span>&nbsp;</span>
                              )}
                            </p>
                          </div>
                        </div>

                        <div className="col-md-6 col-sm-6">
                          <div className="field-container">
                            <label className="field-placeholder font-medium">
                              Screen Resolution:
                            </label>
                            <p className="txtReadOnly fieldReadOnly">
                              {ticketDetail?.RESOLUTION || <span>&nbsp;</span>}
                            </p>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-md-8 col-sm-8 key-right-section">
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <label
                      style={{
                        textAlign: "left",
                        marginLeft: "0",
                        width: "auto",
                        fontWeight: "600",
                      }}
                    >
                      Description:
                    </label>
                    <div>
                      <p
                        style={{
                          color: "black",
                          lineHeight: "21px",
                          fontSize: "13px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: ticketDetail?.COMMENTS || "",
                        }}
                      />
                    </div>
                  </div>
                </div>
                {Trigger.fileDiv && (
                  <div className="row">
                    <div className="col-11">
                      <div style={{ textAlign: "left" }}>
                        {Trigger.attachment && (
                          <>
                            <label
                              style={{
                                textAlign: "left",
                                marginLeft: "0",
                                width: "auto",
                                fontWeight: "600",
                              }}
                            >
                              Attachments:
                            </label>
                            <br />
                            <label
                              id="supportimagemsg"
                              className={`text-left ml-0 w-100 ${
                                Trigger.ErrMsg === true
                                  ? "d-inline-block"
                                  : "d-none"
                              }`}
                            >
                              No attached image found
                            </label>
                          </>
                        )}

                        {TaskhAttachmentFiles != null && (
                          <section>
                            <ul className="p-0">
                              {TaskhAttachmentFiles.FILE_NAME.match(
                                IMAGE_REGEX,
                              ) ? (
                                <li>
                                  {/* ShowTicketImage */}
                                  <span
                                    title="View Image"
                                    onClick={(e) =>
                                      DownloadTaskAttachment(
                                        TaskhAttachmentFiles.FILE_PATH,
                                        TaskhAttachmentFiles.FILE_NAME,
                                        "image",
                                      )
                                    }
                                    style={{
                                      color: "#0b70b8",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <img
                                      src={AttachementFileIcon}
                                      className="IconDocuments"
                                      style={{
                                        verticalAlign: "-3px",
                                        cursor: "pointer",
                                      }}
                                      alt="attachment"
                                    />
                                    &nbsp;
                                    {TaskhAttachmentFiles.FILE_NAME}
                                  </span>
                                </li>
                              ) : (
                                <li>
                                  <span
                                    title="Download Attachment"
                                    onClick={() =>
                                      DownloadTaskAttachment(
                                        TaskhAttachmentFiles.FILE_PATH,
                                        TaskhAttachmentFiles.FILE_NAME,
                                        "file",
                                      )
                                    }
                                    style={{
                                      color: "#0b70b8",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <img
                                      src={AttachementFileIcon}
                                      className="IconDocuments"
                                      style={{
                                        verticalAlign: "-3px",
                                        cursor: "pointer",
                                      }}
                                      alt="attachment"
                                    />
                                    &nbsp; {TaskhAttachmentFiles.FILE_NAME}
                                  </span>
                                </li>
                              )}
                            </ul>
                          </section>
                        )}

                        {Trigger.FileItems &&
                          AttachmentFiles != null &&
                          AttachmentFiles.length > 0 && (
                            <section>
                              <ul className="p-0">
                                {AttachmentFiles != null
                                  ? AttachmentFiles.map((item) =>
                                      item.FILE_NAME.match(IMAGE_REGEX) ? (
                                        <li>
                                          <span
                                            title="View Image"
                                            onClick={(e) =>
                                              DownloadTaskAttachment(
                                                item.FILE_PATH,
                                                item.FILE_NAME,
                                                "image",
                                              )
                                            }
                                            style={{
                                              color: "#0b70b8",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <img
                                              src={AttachementFileIcon}
                                              className="IconDocuments"
                                              style={{
                                                verticalAlign: "-3px",
                                                cursor: "pointer",
                                              }}
                                              alt="attachment"
                                            />
                                            &nbsp;
                                            {item.FILE_NAME}
                                          </span>
                                        </li>
                                      ) : (
                                        <li>
                                          <span
                                            title="Download Attachment"
                                            onClick={() =>
                                              DownloadTaskAttachment(
                                                item.FILE_PATH,
                                                item.FILE_NAME,
                                              )
                                            }
                                            style={{
                                              color: "#0b70b8",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <img
                                              src={AttachementFileIcon}
                                              className="IconDocuments"
                                              style={{
                                                verticalAlign: "-3px",
                                                cursor: "pointer",
                                              }}
                                              alt="attachment"
                                            />
                                            &nbsp; {item.FILE_NAME}
                                          </span>
                                        </li>
                                      ),
                                    )
                                  : ""}
                              </ul>
                            </section>
                          )}
                      </div>
                    </div>
                  </div>
                )}

                {Trigger.attachment ? (
                  <div id="supportattacheimage" className="row">
                    <div className="col-11">
                      <div style={{ textAlign: "left" }}>
                        <img
                          src={AttachementFileIcon}
                          className="IconDocuments cursor-pointer"
                          title="Attach Image"
                          style={{ verticalAlign: "-3px" }}
                          alt="attchment"
                          onChange={(e) => FieldData(e, "attachments")}
                          type="file"
                          name="attachments"
                          multiple
                        />

                        <label
                          style={{
                            width: "auto",
                            float: "none",
                            paddingTop: "0",
                            marginRight: "5px",
                            marginLeft: "0px",
                          }}
                        >
                          Attach Images
                        </label>
                        <input
                          type="file"
                          name="attachments"
                          multiple
                          id="attachSupportTicketfile"
                          onChange={(e) => FieldData(e, "attachments")}
                          style={{ float: "none" }}
                          ref={fileRef}
                        />
                        <br />
                        <span
                          style={{ color: "red" }}
                          id="TicketDetail_spanFileMaxLength"
                        >
                          File size must not exceeds 30 MB
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="row" style={{ marginBottom: "12px" }}>
                  <div className="col-md-12 col-sm-12">
                    <div className="tabbable">
                      <ul className="border-bottom key-nav-tabs">
                        <li
                          onClick={showComments}
                          className={`${boxes.comments ? "active" : ""}`}
                        >
                          <span
                            className="text-decoration-none cursor-pointer"
                            data-toggle="tab"
                          >
                            Comments
                          </span>
                        </li>
                        <li
                          onClick={showHistory}
                          className={`${boxes.history ? "active" : ""}`}
                        >
                          <span
                            className="text-decoration-none cursor-pointer"
                            data-toggle="tab"
                          >
                            Change History
                          </span>
                        </li>
                        <li
                          onClick={showResolution}
                          className={`${boxes.resolution ? "active" : ""}`}
                        >
                          <span
                            className="text-decoration-none cursor-pointer"
                            data-toggle="tab"
                          >
                            Resolution
                          </span>
                        </li>
                      </ul>
                      <div
                        className="tab-content-wrapper"
                        style={{
                          height: CalculateHeight(),
                          maxHeight: CalculateHeight(),
                          overflow: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        <div
                          className={`${
                            boxes.comments ? "d-block" : "d-none"
                          } tab-pane`}
                        >
                          {CommentsData.length > 0 &&
                            CommentsData.map((comment, key) => {
                              const data = {
                                commentData: comment,
                                resolutionAdded: ResolutionCheck,
                              };
                              return (
                                <MessageBox
                                  item={data}
                                  resolutionCallback={ManageResolutionState}
                                />
                              );
                            })}
                        </div>

                        <div
                          className={`${
                            boxes.history ? "d-block" : "d-none"
                          } tab-pane`}
                        >
                          {HistoryData != null &&
                            HistoryData.length > 0 &&
                            HistoryData.map((history, key) => {
                              const data = {
                                historyData: history,
                              };
                              return <HistoryBox item={data} />;
                            })}
                        </div>

                        <div
                          className={`${
                            boxes.resolution ? "d-block" : "d-none"
                          } tab-pane`}
                        >
                          <div className="col-md-12 col-sm-12">
                            <div className="commentsBox">
                              <div className="commentsTextarea">
                                <TextAreaField
                                  id="resolutionDesc"
                                  rows={2}
                                  width={false}
                                  cols={20}
                                  label="Ticket Description:"
                                  disabled={true}
                                  value={FieldValue("resolutionDesc")}
                                  ReceivedTextData={FieldData}
                                />
                              </div>

                              <div className="commentsTextarea">
                                <TextAreaField
                                  id="resolutionTxt"
                                  label="Resolution:"
                                  disabled={true}
                                  value={FieldValue("resolutionTxt")}
                                  ReceivedTextData={FieldData}
                                />

                                <input
                                  type="hidden"
                                  value={Detail.resolutionSeqNum}
                                />
                                <input
                                  type="hidden"
                                  value={Detail.commentSeqNum}
                                />
                              </div>

                              {/* boxes.resolutionBox */}

                              <div className="commentsBtn">
                                <input
                                  type="button"
                                  disabled={boxes.resolutionBtn ? true : false}
                                  className="btnLinkGreen"
                                  value="Save Resolution"
                                  onClick={SaveResolution}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row align-items-end mb-2">
                  <div className="col-md-4 col-sm-4">
                    <label className="font-medium">Add Comments:</label>
                  </div>
                  <div className="col-md-3 col-sm-3">
                    <CheckBoxField
                      id="notify"
                      label="Notify User"
                      disabled={boxes.notify}
                      value={FieldValue("notify")}
                      ReceivedTextData={FieldData}
                    />
                  </div>
                  <div className="col-md-5 col-sm-5">
                    <div
                      className="field-container"
                      style={{ minHeight: "auto" }}
                    >
                      <label
                        className="field-placeholder pr-2 pt-2 font-medium"
                        style={{ width: "50%", textAlign: "right" }}
                      >
                        Viewable By
                      </label>
                      <select
                        className="field-input border border-2"
                        style={{ width: "50%", float: "right" }}
                        value={Detail.viewable}
                        name="viewable"
                        disabled={boxes.viewable}
                        onChange={(e) => UpdateTicketInfo(e)}
                      >
                        {TICKET_TASK_FILTERS.VIEW_ABLES.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row textEditor">
                  <div className="col-12">
                    <TextAreaField
                      id="replyComment"
                      width
                      rows={10}
                      cols={40}
                      label={false}
                      disabled={boxes.select}
                      value={FieldValue("replyComment")}
                      ReceivedTextData={FieldData}
                      click
                      length={4000}
                    />
                  </div>
                </div>
                <div className="row-form">
                  <div>
                    <div className="row">
                      <div className="col-md-12 col-sm-12">
                        <section className="mt-2" disabled={boxes.files}>
                          <div
                            {...getRootProps({
                              className: "dropzone uploadInput",
                            })}
                          >
                            <div className="dragDrop">
                              <div className="inside">
                                <input {...getInputProps()} />
                                <span className="dropzone-content">
                                  <span>Drop files here</span>
                                </span>
                                <span className="ml-2">
                                  <FontAwesomeIcon
                                    icon="upload"
                                    color="black"
                                    size="sm"
                                  />
                                  File Upload
                                </span>
                              </div>
                            </div>
                          </div>
                          {files.length > 0 && (
                            <div className="file-list rounded mt-3">
                              {files}
                            </div>
                          )}
                        </section>
                      </div>
                    </div>
                    <span
                      style={{ color: "red" }}
                      id="CommentDetail_spanFileMaxLength"
                    >
                      File size must not exceed 30 MB
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <input
                      type="button"
                      className="btnLinkGreen btnUpdate"
                      onClick={() => updateTicket()}
                      value="Update"
                    />

                    {Detail?.status !== "R" && (
                      <input
                        type="button"
                        className="btnLinkGreen btnUpdate"
                        onClick={() => ShowMerge()}
                        value="Merge"
                      />
                    )}
                    <input
                      type="button"
                      className="btnLinkBlue"
                      value="Back to List"
                      onClick={() => ShowPreviousData()}
                    />
                    <span
                      id="reloadBtn"
                      className="k-i-refresh k-icon pl-1 cursor-pointer"
                      onClick={() => RefreshTickeDetail()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default TicketDetail;
